export default __webpack_public_path__ + "static/media/earthLogo.959e4c3f.svg";